import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { MARKET_TRENDS_FIELD_NAMES } from '../../utils/form';

export const MarketTrendRow: FC<IProps> = memo(({ name, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, MARKET_TRENDS_FIELD_NAMES.TREND_NAME)}
            name={concatWithDot(name, MARKET_TRENDS_FIELD_NAMES.TREND_NAME)}
            label={t('marketAnalysisForm.overview.marketTrends.name')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInputControl
            multiline
            control={control}
            id={concatWithDot(name, MARKET_TRENDS_FIELD_NAMES.TREND_CHARACTERISTICS)}
            name={concatWithDot(name, MARKET_TRENDS_FIELD_NAMES.TREND_CHARACTERISTICS)}
            label={t('marketAnalysisForm.overview.marketTrends.characteristics')}
            maxLength={500}
            minRows={4}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
